import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Loadable from "../../components/customComponents/Loadable.jsx";
import GasMessageCenterView from "../../../features/view/admin/GasViewMessageCenter/index.jsx";
import MessageForCentricUser2 from "../../view/admin/MyAccount/message/MessageQueue.jsx";
import ManageFiberService from "../../view/admin/MyAccount/ManageFiberService/ManageFiberService.jsx";
import FiberEnrollmentIssue from "../../view/admin/MyAccount/FiberEnrollmentIssue/FiberEnrollmentIssue.jsx";
import CommunityManagement from "../../view/admin/MyAccount/CommunityManagement/CommunityManagement.jsx";
import AddCommunity from "../../view/admin/MyAccount/CommunityManagement/AddCommunity.jsx";
import ManageMyAccountLogins from "../../view/admin/MyAccount/ManageMyAccLogin/index.jsx";
import PostbackHandler from "../../../features/view/admin/PaymentMethodReg/postBackHandler.jsx";
import BaseLayout from "../../layouts/baseLayout";
import Alianza from "../../view/admin/MyAccount/Alianza/index.jsx";
import Onts from "../../../features/view/admin/FiberOperations/Onts.jsx";
import Subscriber from "../../../features/view/admin/FiberOperations/Subscriber.jsx";

const NotFound = Loadable(lazy(() => import("../../view/admin/NotFound")));
// const MyAccountPage = Loadable(lazy(() => import('../../view/home/index.jsx')));

const MyAccountPage = Loadable(
  lazy(
    () =>
      new Promise((resolve) => {
        // setTimeout(() => {
        resolve(import("../../view/home/index.jsx"));
        // }, 2000);
      }),
  ),
);

const LoginPage = Loadable(
  lazy(() => import("../../view/admin/Login/loginPage.jsx")),
);
const LoginPageAdmin = Loadable(
  lazy(() => import("../../view/admin/LoginNew/loginAdminPage.jsx")),
);
const LoginWithOtp = Loadable(
  lazy(() => import("../../view/admin/LoginWithOtp/loginWithOtp.jsx")),
);

const EditAccountPage = Loadable(
  lazy(() => import("../../view/admin/EditAccount/editAccount.jsx")),
);
const ServiceTicketList = Loadable(
  lazy(() => import("../../view/admin/ServiceTicket/index.jsx")),
);
const ManageContactsList = Loadable(
  lazy(() => import("../../view/admin/ManageContacts/manageContacts.jsx")),
);
const ManageAnnouncements = Loadable(
  lazy(
    () =>
      import("../../view/admin/ManageAnnouncements/ManageAnnouncements.jsx"),
  ),
);
const DepositAccounts = Loadable(
  lazy(() => import("../../view/admin/DepositAccounts/DepositAccounts.jsx")),
);
const EnrollmentQueue = Loadable(
  lazy(() => import("../../view/admin/EnrollmentQueue/EnrollmentQueue.jsx")),
);
const BulkSmxsfUpdate = Loadable(
  lazy(() => import("../../view/admin/BulkSmxsfUpdate/BulkSmxsfUpdate.jsx")),
);
const IssueCredit = Loadable(
  lazy(() => import("../../view/admin/IssueCredit/IssueCredit.jsx")),
);
const EnrollmentApp = Loadable(
  lazy(() => import("../../view/admin/EnrollmentApp/EnrollmentApp.jsx")),
);
const Disconnection = Loadable(
  lazy(() => import("../../view/admin/Disconnection/Disconnection.jsx")),
);
const DailySales = Loadable(
  lazy(() => import("../../view/admin/DailySales/dailySales.jsx")),
);
const ReportGeneration = Loadable(
  lazy(() => import("../../view/admin/ReportGeneration/ReportGeneration.jsx")),
);
const ManageMyAccUsers = Loadable(
  lazy(() => import("../../view/admin/ManageMyAccUsers/ManageMyAccUsers.jsx")),
);
const FiberOperations = Loadable(
  lazy(() => import("../../view/admin/FiberOperations/FiberOperations.jsx")),
);
const PaymentMethodList = Loadable(
  lazy(() => import("../../view/admin/PaymentMethodReg/paymentMethodList.jsx")),
);
const Payment = Loadable(lazy(() => import("../../view/admin/Payment/index")));
const PaymentSuccessComponenet = Loadable(
  lazy(() => import("../../view/admin/PaymentSuccess/index")),
);
const CreateServiceTicket = Loadable(
  lazy(() => import("../../view/admin/ServiceTicket/createServiceTicket.jsx")),
);

const CreateMeterServiceTicket = Loadable(
  lazy(
    () => import("../../view/admin/ServiceTicket/createMeterServiceTicket.jsx"),
  ),
);

const CreateGasLineServiceTicket = Loadable(
  lazy(
    () =>
      import("../../view/admin/ServiceTicket/createGasLineServiceTicket.jsx"),
  ),
);

const CreateFiberServiceTicket = Loadable(
  lazy(
    () => import("../../view/admin/ServiceTicket/createFiberServiceTicket.jsx"),
  ),
);

const CreateRequestPage = Loadable(
  lazy(() => import("../../view/admin/Request/index.jsx")),
);
const ViewServiceTicket = Loadable(
  lazy(() => import("../../view/admin/ServiceTicket/viewServiceTicket.jsx")),
);
const BillingHistory = Loadable(
  lazy(() => import("../../view/admin/BillingHistory/BillingHistory.jsx")),
);
const TransactionHistory = Loadable(
  lazy(
    () => import("../../view/admin/TransactionHistory/TransactionHistory.jsx"),
  ),
);

const PaymentHistory = Loadable(
  lazy(() => import("../../view/admin/Payment/PaymentHistory/index.jsx")),
);

const SubAccounts = Loadable(
  lazy(() => import("../../view/admin/SubAccounts/subAccounts")),
);
const ManagePayment = Loadable(
  lazy(() => import("../../view/admin/ManagePayment/ManagePayment.jsx")),
);
const ManageDocuments = Loadable(
  lazy(() => import("../../view/admin/ManageDocuments/ManageDocuments.jsx")),
);
const FaqPage = Loadable(lazy(() => import("../../view/admin/Faq/faq.jsx")));
const ResourceCenter = Loadable(
  lazy(() => import("../../view/resourceCenter")),
);
const TvPin = Loadable(lazy(() => import("../../view/tvPin")));
const ContactUs = Loadable(
  lazy(() => import("../../view/getSupport/contactUs.js")),
);
const FiberServices = Loadable(
  lazy(() => import("../../view/admin/FiberServices/index.js.jsx")),
);

const Support = Loadable(
  lazy(() => import("../../view/admin/MyAccount/Support/Support.js")),
);
const TroubleShoot = Loadable(
  lazy(() => import("../../view/admin/MyAccount/TroubleShoot/TroubleShoot.js")),
);

const ManageCommunicationPreferennce = Loadable(
  lazy(() => import("../../view/admin/ManageComPreference")),
);
const AddPaymentMethods = Loadable(
  lazy(() => import("../../view/paymentMethod/index.js")),
);

const LinkPayment = Loadable(
  lazy(() => import("../../view/paymentMethod/linkPayment.js")),
);

const PaymentRegAdmin = Loadable(
  lazy(() => import("../../view/admin/PaymentMethodReg/admin.jsx")),
);
const PaymentRegAdminAcc = Loadable(
  lazy(
    () => import("../../view/admin/PaymentMethodReg/Account/pracccreate.jsx"),
  ),
);

const ManagePreferennce = Loadable(
  lazy(() => import("../../view/admin/ManagePreference/index.jsx")),
);

const GasUssageHistory = Loadable(
  lazy(() => import("../../view/admin/GasUssageHistory")),
);
const PropertiesPage = Loadable(
  lazy(() => import("../../view/admin/Properties/index.jsx")),
);
const RegisterPage = Loadable(
  lazy(() => import("../../view/admin/Register/index.js")),
);
const Forgotpassword = Loadable(
  lazy(() => import("../../view/admin/Forgotpassword/index.js")),
);

const AdminPage = Loadable(
  lazy(() => import("../../view/admin/Settings/index.jsx")),
);

const VoipAliaze = Loadable(lazy(() => import("../../view/voipAlianza")));

const SecuritySettings = Loadable(
  lazy(() => import("../../view/securitySettings")),
);

const CommunitiesPage = Loadable(
  lazy(() => import("../../view/admin/MyAccount/Developer/communities.jsx")),
);

const CentricEmployee = Loadable(
  lazy(() => import("../../view/admin/MyAccount/CentricEmployee/index.jsx")),
);

const DataAnalysis = Loadable(
  lazy(() => import("../../view/admin/Analysis/DataAnalysis.jsx")),
);

const RoutePage = () => {
  return (
    <>
      <Routes>
        <Route path="payment/postback" element={<PostbackHandler />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/adlgn" element={<LoginPageAdmin />} />
        <Route path="/loginWithOtp" element={<LoginWithOtp />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<Forgotpassword />} />
        <Route
          path="/pymt"
          element={<AddPaymentMethods />}
        />
        <Route
          path="/linkpymt"
          element={<LinkPayment />}
        />
        <Route path={`${process.env.PUBLIC_URL}/`} element={<BaseLayout />}>
          <Route path="/" element={<MyAccountPage />} />
          <Route path="/analysis" element={<DataAnalysis />} />
          <Route path="/home" element={<CentricEmployee />} />
          <Route path="/editAccount" element={<EditAccountPage />} />
          <Route
            path="/serviceTicketCreate"
            element={<CreateServiceTicket />}
          />
          <Route
            path="/meterTicketCreate"
            element={<CreateMeterServiceTicket />}
          />
          <Route
            path="/gasServiceTicketCreate"
            element={<CreateGasLineServiceTicket />}
          />
          <Route
            path="/fiberServiceTicketCreate"
            element={<CreateFiberServiceTicket />}
          />
          <Route path="/serviceTicketView" element={<ViewServiceTicket />} />
          <Route path="/serviceTicket" element={<ServiceTicketList />} />
          <Route path="/manageContacts" element={<ManageContactsList />} />
          <Route
            path="/manageAnnouncements"
            element={<ManageAnnouncements />}
          />
          <Route path="/depositAccounts" element={<DepositAccounts />} />
          <Route path="/enrollmentQueue" element={<EnrollmentQueue />} />
          <Route path="/bulksmxsfupdate" element={<BulkSmxsfUpdate />} />

          <Route path="/issueCredit" element={<IssueCredit />} />
          <Route path="/enrollmentApp" element={<EnrollmentApp />} />
          <Route path="/disconnection" element={<Disconnection />} />
          <Route path="/dailySales" element={<DailySales />} />
          <Route path="/reportGeneration" element={<ReportGeneration />} />
          <Route
            path="/manage-myaccount-users"
            element={<ManageMyAccUsers />}
          />
          <Route
            path="/fiberOperations/network"
            element={<FiberOperations />}
          />
          <Route path="/fiberOperations/onts" element={<Onts />} />
          <Route path="/fiberOperations/subscriber" element={<Subscriber />} />
          <Route path="/messageCenter" element={<GasMessageCenterView />} />
          <Route path="/messageQueue" element={<MessageForCentricUser2 />} />
          <Route path="/manageFiberService" element={<ManageFiberService />} />
          <Route
            path="/fiberEnrollmentIssue"
            element={<FiberEnrollmentIssue />}
          />
          <Route
            path="/communityManagement"
            element={<CommunityManagement />}
          />
          <Route path="/AddCommunity" element={<AddCommunity />} />
          <Route path="/myAcclogin" element={<ManageMyAccountLogins />} />
          <Route path="/billingHistory" element={<BillingHistory />} />
          <Route path="/transactionHistory" element={<TransactionHistory />} />
          <Route path="/paymentHistory" element={<PaymentHistory />} />
          <Route path="/SubAccounts" element={<SubAccounts />} />
          <Route path="/managePayment" element={<ManagePayment />} />
          <Route path="/manageDocuments" element={<ManageDocuments />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/resourceCenter" element={<ResourceCenter />} />
          <Route path="/contactUs" element={<ContactUs />} />
          <Route path="/fiber-service" element={<FiberServices />} />
          <Route path="/troubleShoot" element={<TroubleShoot />} />
          <Route path="/support" element={<Support />} />
          <Route path="/paymentMethodReg" element={<PaymentMethodList />} />
          <Route path="/payment" element={<Payment />} />
          <Route
            path="/paymentSuccess"
            element={<PaymentSuccessComponenet />}
          />
          <Route path="/properties" element={<PropertiesPage />} />
          <Route path="/createRequest" element={<CreateRequestPage />} />
          <Route path="/gasUssageHistory" element={<GasUssageHistory />} />
          <Route path="/voipCustomer" element={<VoipAliaze />} />
          <Route path="/tvPin" element={<TvPin />} />
          <Route path="/securitySettings" element={<SecuritySettings />} />
          <Route path="/alianza" element={<Alianza />} />
          <Route
            path="/communicationPreference"
            element={<ManageCommunicationPreferennce />}
          />

          {/* <Route path="/pradmin" element={<PaymentRegAdmin />} />
          <Route path="/pracc" element={<PaymentRegAdminAcc />} /> */}
          <Route path="/communities" element={<CommunitiesPage />} />
          <Route path="/managePreference" element={<ManagePreferennce />} />
          <Route path="/admin/settings" element={<AdminPage />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/not-found" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
};
export default RoutePage;
